/**
 * @module HojasGasto
 */
import axios from 'api/axios'
import { useCallback, useEffect, useState } from 'react'

const useFetchOptionsHojasGasto = ({ ejercicio = new Date().getFullYear() }) => {
  const [response, setResponse] = useState([])
  const [error, setError] = useState('')
  const [loading, setLoading] = useState(false)

  const fetchData = useCallback(() => {
    if (loading) {
      return
    }

    setLoading(true)
    axios
      .get(`/hojasgasto/options?ejercicio=${ejercicio}`)
      .then((request_response) => {
        const data = request_response.data
        setResponse(data)
      })
      .catch((error) => setError(error))
      .finally(() => setLoading(false))
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [ejercicio])

  useEffect(() => {
    if (!loading) fetchData()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [fetchData, ejercicio])

  return { response, error, loading }
}

export default useFetchOptionsHojasGasto
